import React from 'react';
import styled from 'styled-components';

interface CardProps {
  children: React.ReactNode;
}

export const Card = styled.div<CardProps>`
  background: ${({ theme }) => theme.colors.white};
  border-radius: ${({ theme }) => theme.components.card.borderRadius};
  box-shadow: ${({ theme }) => theme.components.card.boxShadow};
  padding: ${({ theme }) => theme.components.card.padding};
`;

export const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${({ theme }) => theme.spacing[4]};
`;

export const Title = styled.h2`
  font-size: ${({ theme }) => theme.typography.fontSize.xl};
  font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};
  color: ${({ theme }) => theme.colors.text};
  margin: 0;
`;

export const StatusBadge = styled.span<{ color: string }>`
  padding: ${({ theme }) => `${theme.spacing[1]} ${theme.spacing[2]}`};
  border-radius: ${({ theme }) => theme.borderRadius.base};
  font-size: ${({ theme }) => theme.typography.fontSize.sm};
  background: ${props => props.color};
  color: ${({ theme }) => theme.colors.white};
`; 